import { NoxusAlert } from "@/components/UI/NoxusAlert";
import { cn } from "@/lib/utils";

// Shown wherever a deployment or trigger is left tracking the current
// definition: there is no validity gate between an edit and production.
export const CurrentVersionWarning = ({
  entity = "workflow",
  className,
}: {
  entity?: "workflow" | "agent";
  className?: string;
}) => (
  <NoxusAlert
    className={cn("mt-2", className)}
    variant="warning"
    description={`This tracks the ${entity}'s current definition, so every edit goes live immediately. Behaviour can change without warning, and an invalid ${entity} will cause runs to fail. Save a version and pin to it for a stable deployment.`}
  />
);
